import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'bankAccount',
})
export class BankAccountPipe implements PipeTransform {

    transform(accountNumber: string | null | undefined): string {
        if (!accountNumber) {
            return '-';
        }
        const cleanNumber = accountNumber.replace(/\s+/g, '');
        return cleanNumber.replace(/(\d{2})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})/g, '$1 $2 $3 $4 $5 $6 $7');
    }
}
